import { gql } from '@apollo/client';

export const DOCUMENT_TYPE_WITH_ALLOWED_STATES_QUERY = gql`
  query documentTypeWithAllowedStates($id: Int!) {
    documentTypeWithAllowedStates(id: $id) {
      id
      code
      name
      allowedStates {
        id
        documentStateId
        documentStateCode
        documentStateName
        documentColor
        requestComment
        commentIsMandatory
        requestReason
        isActive
        userGroups {
          documentAllowedStateId
          userGroupId
        }
      }
    }
  }
`;
